import {SimplePageLayout} from '@flexinet/ui-components';
import {ApplicationProductsComponent, useApplicationProducts} from '@flexinet/pricing-components';
import {useEffect} from 'react';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from '../navigation/IndexPageNavigation';
import {SubscriptionStatusBanner} from '../../../components/SubscriptionStatusBanner.tsx';

export const IndexPage = () => {

    const {
        items: applicationProducts,
        handleFetchRecords
    } = useApplicationProducts();

    useEffect(() => {
        handleFetchRecords();
    }, []);

    const products = applicationProducts?.map((applicationProduct) => applicationProduct.product);

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader/>}
            pageNavigation={<IndexPageNavigation/>}
        >
            {products ?
                <>
                    <SubscriptionStatusBanner/>
                    <ApplicationProductsComponent products={products}/>
                </> : null}
        </SimplePageLayout>
    );
};
